import { render, staticRenderFns } from "./DividendHistoryTable.vue?vue&type=template&id=8f3282d6&scoped=true&"
import script from "./DividendHistoryTable.vue?vue&type=script&lang=js&"
export * from "./DividendHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./DividendHistoryTable.vue?vue&type=style&index=0&id=8f3282d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3282d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
